import { RootState } from 'pages/_store/root-reducer';
import { OfferType, OwnershipType } from 'types';

const extractOrder = (state: RootState) => state.orderPage.order;
const extractFinanceConditions = (state: RootState) => state.orderPage.financeConditions;
const extractIsFetchingResult = (state: RootState) => state.orderPage.isFetchingResult;
const getIsOEM = (state: RootState) => extractOrder(state)?.offerType === OfferType.OEM;
const getIsPrivateCredit = (state: RootState) => extractOrder(state)?.ownershipType === OwnershipType.PRIVATE_CREDIT;
const getTeslaTrimCodes = (state: RootState) => state.orderPage.teslaTrimCodes;
const getIsFetchingTeslaTrimCodes = (state: RootState) => state.orderPage.isFetchingTeslaTrimCodes;

export default {
  extractOrder,
  extractIsFetchingResult,
  extractFinanceConditions,
  getIsOEM,
  getIsPrivateCredit,
  getTeslaTrimCodes,
  getIsFetchingTeslaTrimCodes,
};
